import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const carData = [
  {
    name: "Hyundai Creta",
    type: "SUV",
    seats: "5 Seater",
    transmission: "Manual / Automatic",
    price: "₹3000 / day",
    img: "https://ackodrive-prod.ackoassets.com/image/hyundai/creta/atlas-white-with-abyss-black/images_cdn/small/Transparent.webp"
  },
  {
    name: "Innova Crysta",
    type: "SUV",
    seats: "7 Seater",
    transmission: "Manual",
    price: "₹3500 / day",
    img: "https://i.ibb.co/WN7xGcKC/innova-crysta.jpg"
  },
  {
    name: "Honda City",
    type: "Sedan",
    seats: "5 Seater",
    transmission: "Manual / Automatic",
    price: "₹2000 / day",
    img: "https://www.hondacarindia.com/web-data/models/2023/city5thGen/Experience/Colors+/Colors/Desktop/Ar_Vk_Honda-City_3TX_Front-3-4th-Studio-Shot_Radiant-Red-Matellic_V2.png"
  },
  {
    name: "Maruti Brezza",
    type: "SUV",
    seats: "5 Seater",
    transmission: "Manual / Automatic",
    price: "₹2700 / day",
    img: "https://www.v3cars.com/media/model-imgs/1656581629-Maruti%20Suzuki%20Brezza%20Exterior.webp"
  },
  {
    name: "Swift Dzire",
    type: "Sedan",
    seats: "5 Seater",
    transmission: "Manual",
    price: "₹1800 / day",
    img: "https://i.ibb.co/HDBRhYwW/maruti-swift.avif"
  }
];

export default function Cars() {
  const [filter, setFilter] = useState("All");
  const [selectedCar, setSelectedCar] = useState(null);
  const [range, setRange] = useState([null, null]);
  const [startDate, endDate] = range;

  useEffect(() => {
    document.body.style.overflow = selectedCar ? "hidden" : "";
  }, [selectedCar]);

  const filteredCars =
    filter === "All" ? carData : carData.filter(c => c.type === filter);

  const calculateDays = () => {
    if (!startDate || !endDate) return 0;
    return Math.ceil((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1;
  };

  const bookOnWhatsApp = () => {
    const days = calculateDays();

    const message = `Hello Cherry Self Drive Cars,

I want to book *${selectedCar.name}* 🚗

📅 From: ${startDate.toLocaleDateString()}
📅 To: ${endDate.toLocaleDateString()} (${days} days)

Type: ${selectedCar.type}
Seating: ${selectedCar.seats}
Transmission: ${selectedCar.transmission}

Is the vehicle available for these dates?`;

    window.open(
      `https://wa.me/919052885299?text=${encodeURIComponent(message)}`,
      "_blank"
    );

    setSelectedCar(null);
    setRange([null, null]);
  };

  return (
    <>
      <section className="cars-header">
        <h1>Our Car Fleet</h1>
        <p>Choose from a wide range of well-maintained self drive cars.</p>
      </section>

      <div className="car-filter">
        <button onClick={() => setFilter("All")}>All</button>
        <button onClick={() => setFilter("SUV")}>SUV</button>
        <button onClick={() => setFilter("Sedan")}>Sedan</button>
      </div>

      <section className="cars-section">
        <div className="cars-grid">
          {filteredCars.map((car, i) => (
            <div className="car-card-modern" key={i}>
              <div className="car-img-wrap">
                <img src={car.img} alt={car.name} />
              </div>

              <h3>{car.name}</h3>

              <div className="car-meta">
                <span>🚘 {car.type}</span>
                <span>👥 {car.seats}</span>
                <span>⚙️ {car.transmission}</span>
              </div>

              <p className="car-price">{car.price}</p>

              <button className="btn-gradient" onClick={() => setSelectedCar(car)}>
                Book Now
              </button>
            </div>
          ))}
        </div>
      </section>

      {selectedCar &&
        createPortal(
          <div className="modal-overlay" onClick={() => setSelectedCar(null)}>
            <div className="modal-box" onClick={e => e.stopPropagation()}>
              <button className="modal-close" onClick={() => setSelectedCar(null)}>✕</button>

              <h2>Book {selectedCar.name}</h2>

              <DatePicker
                selectsRange
                startDate={startDate}
                endDate={endDate}
                onChange={setRange}
                minDate={new Date()}
                inline
              />

              {startDate && endDate && (
                <p className="days-count">{calculateDays()} days selected</p>
              )}

              <div className="modal-actions">
                <button className="btn-outline" onClick={() => setSelectedCar(null)}>Cancel</button>
                <button
                  className="btn-gradient"
                  disabled={!startDate || !endDate}
                  onClick={bookOnWhatsApp}
                >
                  Continue to WhatsApp
                </button>
              </div>
            </div>
          </div>,
          document.body
        )
      }
    </>
  );
}
